<template>
  <div class="essential_information">
    <div class="tabs">
      <span></span>基本信息
      <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
        <i v-show="isEdit" class="tabs_one" @click="goEssentialInformation"></i>
      </el-tooltip>
    </div>
    <el-form v-if="FormDataOne" :inline="true" :label-position="labelPosition" label-width="100px"
      :rules="ruleFormDataOne" ref="ruleFormDataOne" :model="FormDataOne">
      <el-form-item label="姓 名" prop="user_name">
        <el-input v-model="FormDataOne.user_name" maxlength="30" :disabled="isDis" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item label="性 别" prop="sex" label-width="173px" class="sex">
        <el-radio-group v-model="FormDataOne.sex" :disabled="isDis">
          <el-radio label="男" value="1"></el-radio>
          <el-radio label="女" value="0"></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="出生年月" prop="birthday_at">
        <el-date-picker type="date" placeholder="选择日期" :disabled="isDis" value-format="yyyy-MM-dd"
          v-model="FormDataOne.birthday_at">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="联系方式" prop="phone">
        <el-input v-model="FormDataOne.phone" maxlength="30" :disabled="isDis" placeholder="请输入联系方式"></el-input>
      </el-form-item>
    </el-form>
    <div class="btn" v-if="!isDis">
      <el-button class="cancel" @click="cancel">取消</el-button>
      <el-button class="preservation" @click="preservation">保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userInfo: {
      type: Object
    }
  },
  computed: {
    isEdit () {
      if (this.auditStatus === 1) {
        return false
      } else {
        return this.isDis
      }
    },
  },
  watch: {
    userInfo: {
      handler (newVale, oldVale) {
        if (newVale.num === 1) {
          this.id = newVale.id
          this.auditStatus = newVale.auditStatus
          this.certificateUrls = newVale.certificateUrls
          this.FormDataOne.user_name = newVale.userName;
          this.FormDataOne.sex = newVale.sex;
          if (this.FormDataOne.sex === 1) {
            this.FormDataOne.sex = "男"
          } else if (this.FormDataOne.sex === 0) {
            this.FormDataOne.sex = "女"
          } else {
            this.FormDataOne.sex = ""
          }
          this.FormDataOne.phone = newVale.phone;
          this.FormDataOne.birthday_at = newVale.birthdayAt;
          this.dataObj = { ...this.FormDataOne } // 解构对象，取消操作用解构对象
        }
      },
      deep: true,
      immediate: true
    },
  },
  data () {
    let myPnone = (rule, value, callback) => {
      let reg = /^1\d{10}$/;
      if (!value) {
        return callback(new Error("请输入手机号"));
      }
      if (!reg.test(value)) {
        return callback(new Error("手机号不正确"));
      }

      callback();

    };
    return {
      FormDataOne: {
        user_name: "",
        sex: "",
        birthday_at: "",
        phone: "",
      },
      dataObj: {},
      ruleFormDataOne: {
        user_name: [{ required: true, message: '请输入姓名', trigger: 'blur' },],
        sex: [{ required: true, message: '请选择性别', trigger: 'blur' },],
        birthday_at: [{ required: true, message: '请选择日期', trigger: 'blur' },],
        phone: [{ required: true, validator: myPnone, trigger: 'blur' },],
      },
      labelPosition: "left",
      isDis: true,
      id: null,
      auditStatus: null,
    };
  },
  created () {

  },
  methods: {
    goEssentialInformation () {
      this.isDis = false
    },
    async preservation () {
      let verify = true;
      this.$refs.ruleFormDataOne.validateField(["user_name", "sex", "birthday_at", "phone",], errTip => {
        if (errTip) {
          // 会调用多次
          verify = false;
        }
      })
      if (verify) {
        let url = "/v1/userRegister/add_or_update_register_info"
        let myUser = JSON.parse(localStorage.getItem("myUser"))
        let sex
        this.FormDataOne.sex === "男" ? sex = 1 : sex = 0

        let params = {
          id: this.id,
          auditStatus: this.auditStatus === 0 ? 0 : 2,
          userId: myUser.id,
          userName: this.FormDataOne.user_name,
          phone: this.FormDataOne.phone,
          sex,
          birthdayAt: this.FormDataOne.birthday_at,
          certificateUrls: this.certificateUrls
        }
        const res = await this.catReq1Service(url, params)
        if (res.resultCode === "1") {
          this.isDis = true;
          this.$emit("succe", res.result)
          this.$store.dispatch("businessLicenseUrls", res.result.businessLicenseUrls)
        }
      }
    },
    cancel () {
      this.$refs['ruleFormDataOne'].clearValidate();
      this.FormDataOne = { ...this.dataObj }
      this.isDis = true;
    },
  },
};
</script>

<style lang="less" scoped>
.essential_information {
  .tabs {
    display: flex;
    font-size: 16px;
    align-items: center;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(28, 28, 29, 1);
    margin-bottom: 20px;
    span {
      width: 4px;
      height: 16px;
      background: rgba(30, 134, 230, 1);
      margin-right: 5px;
    }
    .tabs_one {
      display: inline-block;
      cursor: pointer;
      width: 16px;
      height: 16px;
      background: url("../../assets/imgs/authentication/modify_normal.png")
        no-repeat;
      background-size: cover;
      margin-left: 10px;
      &:active {
        background: url("../../assets/imgs/authentication/modify_press.png")
          no-repeat;
      }
    }
  }
  .el-form {
    display: flex;
    flex-wrap: wrap; //flex-grow
    .el-form-item {
      width: 40%;
    }
    .el-input {
      width: 202px;
    }
    .sex {
      .el-radio-group {
        position: relative;
        left: -90px;
      }
      .el-form-item__label {
        margin-left: 50px !important;
      }
      /deep/.el-form-item__error {
        left: -90px !important;
      }
    }
  }
  .btn {
    width: 100%;
    text-align: right;
    .el-button {
      width: 80px;
      height: 36px;
      box-sizing: border-box;
      font-family: Microsoft YaHei;
      font-size: 16px;
      line-height: 0;
    }
    .cancel {
      background: rgba(219, 239, 255, 1);
      border: 1px solid rgba(30, 134, 230, 1);
      box-shadow: 0px 3px 8px 0px rgba(153, 153, 153, 0.5);
      border-radius: 4px;
    }
    .preservation {
      background: rgba(30, 134, 230, 1);
      box-shadow: 0px 3px 8px 0px rgba(30, 134, 230, 0.5);
      border-radius: 4px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      margin-left: 50px;
    }
  }
}
</style>
